import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ApiTokensComponent } from './api-tokens.component';
import { AuthGuard } from '../../guards/auth.guard';

const routes: Routes = [
  {
    path: 'user/api-tokens',
    component: ApiTokensComponent,
    canActivate: [
      AuthGuard
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ApiTokensRoutingModule {}
